import React from "react";
import ReactDom from "react-dom";
import WebApp from "./web/WebApp";
ReactDom.render(<WebApp />, document.getElementById("root"));
